module.exports = function getResource(label, vars = []) {
    const resources = {
        bioEmptyMessage: 'Êtes-vous du signe astrologique Vierge avec une dépendance au brillant à lèvres? Cliquez sur modifier pour vous décrire en une ou deux phrases.',
        fullEmptyMessage: 'Êtes-vous du signe astrologique Vierge avec une dépendance au brillant à lèvres? Cliquez sur modifier pour vous décrire en une ou deux phrases et ajouter vos liens Instagram et YouTube.',
        emptyMessage: 'n’as pas encore ajouté de bio.'
    };
    return resources[label];
};
